import { useId } from 'react';
import { starFills } from '../domain/rating';
import './RatingStars.css';

const STAR_PATH = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z';

/**
 * Five stars drawn next to a rating, half a star for a half point (owner feedback, 2026-09-28).
 * Decorative: the rating is always also written as text next to them.
 */
export function RatingStars({ rating }: { rating: number }) {
  const clipId = `half-star-${useId()}`;
  return (
    <span className="rating-stars" aria-hidden="true">
      <svg width="0" height="0" className="rating-stars__defs">
        <clipPath id={clipId}>
          <rect x="0" y="0" width="12" height="24" />
        </clipPath>
      </svg>
      {starFills(rating).map((fill, index) => (
        <svg key={index} viewBox="0 0 24 24" className="rating-stars__star">
          <path d={STAR_PATH} className="rating-stars__empty" />
          {fill === 'full' && <path d={STAR_PATH} className="rating-stars__filled" />}
          {fill === 'half' && (
            <path d={STAR_PATH} className="rating-stars__filled" clipPath={`url(#${clipId})`} />
          )}
        </svg>
      ))}
    </span>
  );
}
